/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { Fragment } from "react";

import { spacing } from "../../../../../../global/emotion";
import { cssMediaQueryMinWidthTablet } from "../../../../../lib/constants/emotionMediaQueries.constants";
import type { BlockProps } from "../../../../refactor/Block/Block.emotion";
import { Block } from "../../../../refactor/Block/Block.emotion";
import type { NextUpMediumProps } from "../NextUpMedium/NextUpMedium.emotion";
import { NextUpMedium } from "../NextUpMedium/NextUpMedium.emotion";

const actionsStyle: Interpolation = {
  marginTop: spacing.m,
};
const blockStyle: Interpolation = {
  display: "none",
  [cssMediaQueryMinWidthTablet]: { display: "flex" },
};
const nextUpMediumStyle: Interpolation = {
  display: "flex",
  [cssMediaQueryMinWidthTablet]: { display: "none" },
};

export type NextUpLargeProps = {} & Pick<
  NextUpMediumProps,
  | "activeState"
  | "asChild"
  | "children"
  | "color"
  | "description"
  | "focusState"
  | "hoverState"
  | "imgSrc"
  | "rightActions"
  | "subscription"
  | "title"
> &
  Pick<NextUpMediumProps, "tag"> &
  Pick<BlockProps, "actions" | "metadata" | "metadataInlineIcon">;

export const NextUpLarge = ({
  actions,
  activeState = false,
  asChild,
  children,
  color,
  description,
  focusState = true,
  hoverState = true,
  imgSrc,
  metadata,
  metadataInlineIcon,
  rightActions,
  subscription,
  tag,
  title,
}: NextUpLargeProps) => {
  return (
    <Fragment>
      <Block
        actions={actions}
        actionsCSS={actionsStyle}
        activeState={activeState}
        color={color}
        description={description}
        focusState={focusState}
        hoverState={hoverState}
        imgSrc={imgSrc}
        metadata={metadata}
        metadataInlineIcon={metadataInlineIcon}
        subscription={subscription}
        title={title}
        css={blockStyle}
      />
      <NextUpMedium
        centerActions={actions}
        activeState={activeState}
        asChild={asChild}
        children={children}
        color={color}
        description={description}
        focusState={focusState}
        hoverState={hoverState}
        imgSrc={imgSrc}
        rightActions={rightActions}
        subscription={subscription}
        tag={tag}
        title={title}
        css={nextUpMediumStyle}
      />
    </Fragment>
  );
};
